export enum AdministratorsModalEnum {
  AssignAdmins = 'administrators-assign-admins',
  RemoveDisconnectAdmins = 'administrators-remove-admins',
}
